import { useContext } from 'react';
import { FuseSettingsContext, FuseSettingsContextType } from '../FuseSettingsProvider';
import { defaultSettings } from '@fuse/default-settings';
import { FuseSettingsConfigType } from '@fuse/core/FuseSettings/FuseSettings';

// Default context value for when provider isn't ready yet (during lazy loading)
const defaultContextValue: FuseSettingsContextType = {
  data: defaultSettings as FuseSettingsConfigType,
  initial: defaultSettings as FuseSettingsConfigType,
  defaults: defaultSettings as FuseSettingsConfigType,
  setSettings: () => defaultSettings as FuseSettingsConfigType
};

const useFuseSettings = (): FuseSettingsContextType => {
  const context = useContext(FuseSettingsContext);

  // Return default value during lazy loading instead of throwing
  if (!context) {
    return defaultContextValue;
  }

  return context;
};

export default useFuseSettings;
